import i18next from "i18next";
import { LANGUAGE } from "@root/constants";

export const getInitialLanguage = (): string => {
  return LANGUAGE.KOREAN.toLowerCase();
};

/**
 * @param language
 * @description This function changes the application language
 * on the basis of language {string}  passed to it
 */
export const changeAppLanguage = (language: string) => {
  const langCode = language.toLowerCase();
  i18next.changeLanguage(langCode);
};
